import React from "react";
import Layout from "../components/Layout";
import { useLang } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowUpRight, FileText, Download } from "lucide-react";

const BROCHURES = [
  {
    id: "coaching",
    title_fr: "Plaquette Coaching",
    title_en: "Coaching brochure",
    desc_fr: "Notre offre de coaching individuel — méthodologie, formats, durées.",
    desc_en: "Our executive coaching offer — methodology, formats, durations.",
    url: "https://customer-assets.emergentagent.com/job_perspectives-hub/artifacts/hmeovito_AUDACE%20PERSPECTIVES%20plaquette%20coaching%20V1.96.pdf",
    file: "Audace-Perspectives-Coaching.pdf",
  },
  {
    id: "outplacement",
    title_fr: "Plaquette Outplacement",
    title_en: "Outplacement brochure",
    desc_fr: "Programme complet de transition de carrière pour cadres dirigeants.",
    desc_en: "Complete career transition program for senior executives.",
    url: "https://customer-assets.emergentagent.com/job_perspectives-hub/artifacts/7y9vjqea_AUDACE%20%26%20PERSPECTIVES%20plaquette%20outplacement%20V1.96.pdf",
    file: "Audace-Perspectives-Outplacement.pdf",
  },
  {
    id: "networking",
    title_fr: "Networking — Booster de trajectoire",
    title_en: "Networking — Trajectory Booster",
    desc_fr: "Activer son réseau, structurer sa visibilité, accélérer sa trajectoire.",
    desc_en: "Activate your network, structure your visibility, accelerate your trajectory.",
    url: "https://customer-assets.emergentagent.com/job_perspectives-hub/artifacts/1u2vo15k_AUDACE%20PERSPECTIVES%20NETWORKING%20Booster%20de%20trajectoire%20%20V1.96.pdf",
    file: "Audace-Perspectives-Networking.pdf",
  },
  {
    id: "croyances",
    title_fr: "Sortir des croyances limitantes",
    title_en: "Breaking free from limiting beliefs",
    desc_fr: "Identifier, comprendre et dépasser les croyances qui freinent votre trajectoire.",
    desc_en: "Identify, understand and overcome the beliefs that hinder your trajectory.",
    url: "https://customer-assets.emergentagent.com/job_perspectives-hub/artifacts/bhwryppz_AUDACE%20PERSPECTIVES%20Sortir%20des%20Croyances%20limitantes%20%20V1.96.pdf",
    file: "Audace-Perspectives-Croyances-Limitantes.pdf",
  },
];

export default function Resources() {
  const { lang } = useLang();

  return (
    <Layout>
      <article data-testid="resource-article" className="pt-32 md:pt-40">
        <section className="bg-sand py-20 md:py-28 px-6 md:px-10">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-12 gap-6 mb-12">
              <div className="col-span-12">
                <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand mb-5">— {lang === "fr" ? "Ressources" : "Resources"}</div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10 mb-16">
              {BROCHURES.map((b) => (
                <a
                  key={b.id}
                  href={b.url}
                  target="_blank"
                  rel="noreferrer"
                  download={b.file}
                  data-testid={`brochure-${b.id}`}
                  className="group bg-ivory hover:bg-white p-8 md:p-10 flex flex-col gap-5 transition-colors duration-300"
                >
                  <div className="flex items-start justify-between">
                    <FileText size={22} className="text-brand" />
                  </div>
                  <h3 className="font-serif text-2xl font-light text-navy leading-snug">{lang === "fr" ? b.title_fr : b.title_en}</h3>
                  <p className="text-ink/65 text-sm leading-relaxed flex-1">{lang === "fr" ? b.desc_fr : b.desc_en}</p>
                  <div className="hairline bg-black w-12"></div>
                  <span className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.18em] font-mono text-brand group-hover:text-brandDark">
                    <Download size={14} /> PDF
                  </span>
                </a>
              ))}
            </div>

            <div className="border border-navy/15 p-10 md:p-16 bg-ivory flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
              <p className="font-serif text-3xl md:text-4xl font-light leading-tight max-w-2xl text-navy">
                {lang === "fr" ? "Faisons connaissance…" : "Let's get to know each other…"}
              </p>
              <Link to="/contact" data-testid="resource-cta" className="inline-flex items-center gap-4 bg-brand hover:bg-brandDark text-white px-7 py-5 transition-colors">
                <span className="text-sm tracking-[0.16em] uppercase font-mono">
                  {lang === "fr" ? "Prendre contact" : "Get in touch"}
                </span>
                <ArrowUpRight size={18} />
              </Link>
            </div>
          </div>
        </section>
      </article>
    </Layout>
  );
}
